import React from 'react';
import { Grid, Typography, Button, Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { InventoryStatus, BulkInventoryItem } from 'common/modules/inventory';
import { useTranslation } from 'services/localization';
import { getInventoryStatusTranslation } from '../../utils';

interface Props {
	status: InventoryStatus;
	quantity: number | null;
	onEdit: (status: InventoryStatus) => void;
	allocations: BulkInventoryItem['allocations'];
}
const StatusItem = (props: Props) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const { allocations, quantity, status, onEdit } = props;
	const rentalAllocation = allocations?.rental ?? 0;
	const salesAllocation = allocations?.sales ?? 0;

	const onEditClick = () => {
		onEdit(status);
	};

	const renderQuantity = () =>
		status === 'IN_USE' ? (
			<>
				<Typography variant="body1">
					{t('inventory.forRent', 'For rent')}:{' '}
					{rentalAllocation > (quantity ?? 0) ? quantity : rentalAllocation}
				</Typography>
				<Typography variant="body1">
					{t('inventory.forSale', 'For sale')}:{' '}
					{salesAllocation > (quantity ?? 0) ? quantity : salesAllocation}
				</Typography>
			</>
		) : (
			<Typography variant="body1">{quantity}</Typography>
		);

	return (
		<Box px={3} py={1}>
			<Grid container spacing={0} alignItems={status === 'IN_USE' ? 'baseline' : 'center'}>
				<Grid item sm={4}>
					<Typography variant="body1">{getInventoryStatusTranslation(t, status)}:</Typography>
				</Grid>
				<Grid item sm={4}>
					{renderQuantity()}
				</Grid>
				<Grid item sm={4} justifyContent="flex-end" container>
					<Button variant="text" color="primary" onClick={onEditClick} className={classes.textBtn}>
						{t('common:actions.edit')}
					</Button>
				</Grid>
			</Grid>
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		textBtn: {
			minWidth: 'auto',
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(2),
			marginRight: theme.spacing(-2),
		},
	}),
);

export default StatusItem;
